import { Injectable, signal } from '@angular/core';

/**
 * Interface for breadcrumb navigation items
 */
export interface BreadcrumbItem {
  /** Display label for the breadcrumb */
  label: string;
  /** Optional URL for navigation (if not provided, breadcrumb is not clickable) */
  url?: string;
}

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private readonly homepage: BreadcrumbItem = { label: 'Dashboard', url: '/dashboard' };

  private _breadcrumbs = signal<BreadcrumbItem[]>([this.homepage]);

  readonly breadcrumbs = this._breadcrumbs.asReadonly();

  updateBreadcrumbs(breadcrumbs: BreadcrumbItem[]): void {
    this._breadcrumbs.set([this.homepage, ...breadcrumbs]);
  }

  clearBreadcrumbs(): void {
    this._breadcrumbs.set([this.homepage]);
  }

  addBreadcrumb(breadcrumb: BreadcrumbItem): void {
    const current = this._breadcrumbs();
    this._breadcrumbs.set([...current, breadcrumb]);
  }
}
